import { Textures as Tex } from '@Renderer/texturepacks/Links.js';

let copy = JSON.parse(JSON.stringify(Tex));

for (let key in copy) {
	copy[key].images = ['diffuse']
	copy[key].url = copy[key].url.replace('pack002', 'pack002_preview');
	// console.log(copy[key].url)
	// if(key === 'waterSurface') {
	// 	continue
	// }
}
export const Textures = copy
